var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"tile",attrs:{"hover":"","color":_vm.color,"loading":_vm.loading}},[_c('v-card-title',{staticStyle:{"padding-bottom":"0"}},[(_vm.icon !== '')?_c('i',{class:( _obj = { fad: true }, _obj[_vm.icon] = true, _obj )}):_vm._e(),_vm._v(_vm._s(_vm.value == 0 ? "..." : _vm.value))]),_c('v-card-text',[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }